import { devtools } from 'zustand/middleware';

import { type Team } from '@app/client/common/structs';
import { create } from '@app/store/zustand/helpers/create';

type UserTeam = Team & { isOwner?: boolean };

type TeamData = {
    showCreateTeamModal?: boolean;
    showManagementModal?: boolean;
    inspectedTeamData?: Team;
    userIsTeamMember?: boolean;
    summaryTeamId?: string;
    userTeam?: UserTeam;
    teamInviteUrl?: string;
};
interface TeamsState extends TeamData {
    setShowManagementModal: (showManagementModal: boolean) => void;
    setSummaryTeamId: (teamId?: string) => void;
    setInspectedTeamsData: (inspectedTeam?: Team, isTeamMember?: boolean) => void;
    setShowCreateTeamModal: (showManagementModal: boolean) => void;
    setUserTeam: (team: UserTeam | undefined) => void;
    resetTeams: () => void;
}

const initialState: TeamData = {
    summaryTeamId: undefined,
    showManagementModal: false,
    showCreateTeamModal: false,
    userIsTeamMember: false,
};

export const useFantasyTeamsStore = create<TeamsState>()(
    devtools(
        (set) => ({
            ...initialState,
            setSummaryTeamId: (summaryTeamId) => set({ summaryTeamId }),
            setUserTeam: (team) => {
                const fantasyTeamLink = team
                    ? `${window.location.protocol}//${window.location.host}/fantasy/team/invite?inviteLinkHash=${team?.invite_code}`
                    : undefined;
                set({ userTeam: team, teamInviteUrl: fantasyTeamLink });
            },
            setShowManagementModal: (showManagementModal) => set({ showManagementModal }),
            setShowCreateTeamModal: (showCreateTeamModal) => set({ showCreateTeamModal }),
            setInspectedTeamsData: (inspectedTeamData, isTeamMember) =>
                set({ inspectedTeamData, userIsTeamMember: isTeamMember }),
            resetTeams: () => set(initialState),
        }),
        { name: 'fantasy-teams-store' },
    ),
);
